module.exports = new __parcel__URL__("cover.577de99a.webp").toString();